export default __webpack_public_path__ + "static/image_restauration-88b069f616afb6ee092070d2fdcfecf7.jpg";